import { useContext } from 'react';

import { SearchContext, SearchPageType } from 'search/SearchContext';

export const useSearchType = (): SearchPageType => {
    const {
        state: { searchType }
    } = useContext(SearchContext);

    return searchType;
};
